import styled from 'styled-components';
import StageTime from './container';

import { Z_INDEX } from 'modules/journey/stop-status-log/z-index';

export default styled(StageTime)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 2px solid var(--grey100);
  border-left: 2px solid var(--grey100);
  color: var(--grey700);
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${Z_INDEX.TIME};

  .date {
    margin-left: 2rem;
  }
`;
